<template>
  <div>
    <div style="margin: 10px 0">
      <!-- <el-input style="width: 200px;" type="text" v-model="username" placeholder="请输入名称" suffix-icon="el-icon-search"></el-input>
      <el-button style="margin-left: 10px;" type="primary" @click="load" icon="el-icon-search">搜索</el-button> -->
      <el-button type="primary" @click="load" icon="el-icon-refresh">重置</el-button>
      <el-button type="success" icon="el-icon-circle-plus-outline" @click="handAdd()">新增</el-button>
      <el-button style="float:right; margin-left: 10px" type="danger" @click="deleteBatch">批量删除<i class="el-icon-remove-outline"></i></el-button>
      <el-select v-model="pondid" clearable placeholder="请选择要查看的池塘" style="float:right">
        <el-option v-for="item in options2" 
        :key="item.id"
        :label="item.name"
        :value="item.id"></el-option>
      </el-select>
      <el-select v-model="comid" clearable placeholder="请选择要查看的公司" v-if="role === '超级管理员'" style="float:right">
        <el-option v-for="item in options1" 
        :key="item.id"
        :label="item.name"
        :value="item.id"></el-option>
      </el-select>
    </div>
    <el-table :data="filteredTableData" border stripe :header-cell-class-name="headerBg" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <!-- 动态生成的列 -->
      <el-table-column v-for="(label, prop) in dynamicHeaders" :key="prop" :prop="prop" :label="label"></el-table-column>
      <!-- 固定的检测时间列 -->
      <el-table-column prop="date" label="检测时间" width="180"></el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="success"  @click="handEdit(scope.row)">编辑<i class="el-icon-edit"></i></el-button>
          <el-popover
            placement="top"
            width="160"
            trigger="click">
            <p>您确定删除吗</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="handdele(scope.row.id)">确定</el-button>
            </div>
            <el-button type="danger" slot="reference">删除<i class="el-icon-remove-outline"></i></el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div style="padding: 10px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="水质信息" :visible.sync="dialogFormVisible" width="30%">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="所属公司">
          <el-select v-model="form.comid" clearable placeholder="请选择公司" v-if="role === '超级管理员'" @change="handleCompanyChange">
            <el-option v-for="item in options1" 
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属池塘">
          <el-select v-model="form.pondid" clearable placeholder="请选择池塘">
            <el-option v-for="item in options2" 
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检测时间">
          <el-date-picker
            v-model="form.date"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
          <!-- 新增图片上传区域 -->
          <el-form-item label="手写识别">
              <el-upload
                      class="upload-demo"
                      action=""
                      :auto-upload="false"
                      :on-change="handleImageUpload"
                      :show-file-list="false"
                      accept="image/*"
              >
                  <el-button type="primary">上传手写图片</el-button>
                  <div slot="tip" class="el-upload__tip">请上传清晰的手写参数图片（支持中文）</div>
              </el-upload>
          </el-form-item>
          <el-form-item label="书写示例">
              <div style="color: #666; font-size: 12px; line-height: 1.5;">
                  <p>推荐格式（每行一个参数）：</p>
                  <p>氨氮：0.5</p>
                  <p>pH 7.2</p>
                  <p>溶解氧 6.8</p>
                  <p>温度 25</p>
              </div>
          </el-form-item>
        <el-form-item label="选择参数类型">
          <el-checkbox-group v-model="selectedParams">
            <el-checkbox v-for="(label, key) in editableHeaders" :key="key" :label="key">{{ label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div v-for="param in selectedParams" :key="param">
          <el-form-item :label="editableHeaders[param]">
            <el-input v-model="form[param]"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="shutDown">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>请选择公司以及池塘查看数据</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createWorker } from 'tesseract.js';
export default {
  name: "User",
  data () {
    return {
      tableData: [],
      username: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      form: {},
      multipleSelection: {},
      headerBg: 'headerBg',
      data: {},
      dateTimeValue1: '',
      options1: [],
      options2: [],
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      pondid: null,
      comid: null,
      dialogVisible: true,
      role: (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}).role,
      headers: {
        id: 'ID',
        pondid: '池塘ID',
        an: '氨氮(mg/L)',
        nitr: '亚硝酸盐(mg/L)',
        do: '溶解氧(mg/L)',
        tem: '温度(℃)',
        ph: 'pH',
        sal: '盐度(PPT)',
        ec: '电导率(μS/cm)',
        tur: '浊度(NTU)',
        orp: '氧化还原电位(mV)',
        cod: '化学需氧量(mg/L)',
        bod: '生化需氧量(mg/L)',
        tp: '总磷(mg/L)',
        tn: '总氮(mg/L)',
        pb: '铅(mg/L)',
        hg: '汞(mg/L)',
        cd: '镉(mg/L)',
        cr: '铬(mg/L)',
        as: '砷(mg/L)',
        hardness: '硬度(mg/L)',
        alkalinity: '碱度(mg/L)',
        tss: '总悬浮固体(mg/L)',
        tds: '总溶解固体(mg/L)',
        chlorophyll_a: '叶绿素a(mg/L)',
        no3: '硝酸盐(mg/L)',
        po4: '磷酸盐(mg/L)',
        date: '检测时间',
        update_time: '更新时间',
        create_time: '创建时间',
        is_deleted: '是否删除'
      },
      dynamicHeaders: {},
      selectedParams: [],
      editableHeaders: {
        an: '氨氮',
        nitr: '亚硝酸盐',
        do: '溶解氧',
        tem: '温度',
        ph: 'pH',
        sal: '盐度',
        ec: '电导率',
        tur: '浊度',
        orp: '氧化还原电位',
        cod: '化学需氧量',
        bod: '生化需氧量',
        tp: '总磷',
        tn: '总氮',
        pb: '铅',
        hg: '汞',
        cd: '镉',
        cr: '铬',
        as: '砷',
        hardness: '硬度',
        alkalinity: '碱度',
        tss: '总悬浮固体',
        tds: '总溶解固体',
        chlorophyll_a: '叶绿素a',
        no3: '硝酸盐',
        po4: '磷酸盐'
      }
    }
  },
  computed: {
    filteredTableData () {
      return this.tableData.filter(row => {
        return Object.values(row).some(value => value !== null);
      });
    }
  },
  mounted () {
    this.load();
    if (this.role === "超级管理员") {
      this.getcompanies();
    } else {
      this.getPonds(this.user.companyid);
    }
  },
  methods: {
    load () {
      this.request.get('/api/artWaterQualifyData/page', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          pondid: this.pondid,
        }
      }).then(res => {
        this.tableData = res.records;
        this.total = res.total;
        this.updateDynamicHeaders();
      }).catch(error => {
        console.error(error);
      });
    },
    updateDynamicHeaders () {
      const allKeys = new Set();
      this.tableData.forEach(row => {
        Object.keys(row).forEach(key => {
          if (key !== 'id' && key !== 'pondid' && key !== 'date' && key !== 'update_time' && key !== 'create_time' && key !== 'is_deleted') {
            allKeys.add(key);
          }
        });
      });

      const validColumns = {};
      allKeys.forEach(key => {
        if (this.headers[key]) {
          const hasNonNullValue = this.tableData.some(row => row[key] !== null);
          if (hasNonNullValue) {
            validColumns[key] = this.headers[key];
          }
        }
      });

      this.dynamicHeaders = validColumns;
    },
    getcompanies () {
      this.request.get('/api/companies/').then(res => {
        if (res.code === "200") {
          this.options1 = res.data.map(item => {
            return {
              id: item.id,
              name: item.name
            };
          });
        } else {
          console.log(res.code, res.data);
        }
      });
    },
      // 新增图片上传处理
      async handleImageUpload(file) {
          try {
              this.$message.info('开始识别手写内容...');

              const worker = await createWorker({
                  logger: m => console.log(m) // 可选：查看识别进度
              });

              // 加载中文语言包
              await worker.loadLanguage('chi_sim');
              await worker.initialize('chi_sim');

              // 执行OCR识别
              const { data: { text } } = await worker.recognize(file.raw);
              await worker.terminate();

              this.parseHandwrittenText(text);
              this.$message.success('识别成功！');
          } catch (error) {
              console.error('识别失败:', error);
              this.$message.error('识别失败，请确保图片清晰并包含有效数据');
          }
      },

      // 新增文本解析方法
      parseHandwrittenText(text) {
          console.log("识别内容:", text); // 调试用
          // 示例解析逻辑，根据实际需要调整
          const patterns = {
              an: /氨[\s\u4e00-\u9fa5]*(氮)?[\s:：]*([\d.]+)/,
              nitr: /亚硝酸盐[\s:：]*([\d.]+)/,
              do: /溶解氧[\s:：]*([\d.]+)/,
              tem: /温度[\s:：]*([\d.]+)/,
              ph: /pH[\s:：]*([\d.]+)/,
              sal: /盐度[\s:：]*([\d.]+)/,
              ec: /电导率[\s:：]*([\d.]+)/,
              tur: /浊度[\s:：]*([\d.]+)/,
              orp: /氧化还原电位[\s:：]*([\d.]+)/,
              // 其他参数类似...
          };

          let detectedCount = 0;

          // 清空原有选择（可选）
          // this.selectedParams = [];

          // 按行分割处理
          text.split('\n').forEach(line => {
              line = line.trim();
              if (!line) return;

              // 遍历所有参数模式
              for (const [key, regex] of Object.entries(patterns)) {
                  const match = line.match(regex);
                  if (match && match[2]) { // 修改为匹配第二个捕获组
                      const value = parseFloat(match[2]);
                      if (!isNaN(value)) {
                          // 更新表单数据
                          this.$set(this.form, key, value);

                          // 添加参数到选中列表（如果不存在）
                          if (!this.selectedParams.includes(key)) {
                              this.selectedParams = [...this.selectedParams, key];
                          }

                          console.log(`已识别 ${this.editableHeaders[key]}: ${value}`);
                      }
                  }
              }
          });

          // 用户反馈
          if (detectedCount > 0) {
              this.$message.success(`成功识别到 ${detectedCount} 个参数`);
          } else {
              this.$message.warning("未识别到有效参数，请确认书写格式");
          }
      }
      ,
    getPonds (comid) {
      if (isNaN(comid)) {
        comid = 0;
      }
      this.request.get('/api/ponds/getponds', {
        params: {
          comid: comid
        }
      }).then(res => {
        if (res.code === "200") {
          this.options2 = res.data.map(item => {
            return {
              id: item.id,
              name: item.name
            };
          });
        } else {
          console.log(res.msg);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    handleCompanyChange (newComid) {
      this.getPonds(newComid);
    },
    save () {
      this.request.post('/api/artWaterQualifyData/', this.form).then(res => {
        if (res) {
          this.$message.success('保存成功');
          this.dialogFormVisible = false;
          this.load();
        } else {
          this.$message.error('保存失败');
        }
      });
    },
    handAdd () {
      this.dialogFormVisible = true;
      this.form = {};
      this.selectedParams = [];
    },
    handEdit (row) {
      this.form = { ...row };
      this.selectedParams = Object.keys(row).filter(key => this.editableHeaders[key]);
      this.dialogFormVisible = true;
    },
    handdele (id) {
      this.request.delete('/api/artWaterQualifyData/' + id).then(res => {
        if (res) {
          this.$message.success('删除成功');
          this.load();
        } else {
          this.$message.error('删除失败');
        }
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    deleteBatch () {
      let ids = this.multipleSelection.map(val => val.id);
      this.request.delete('/api/user/del/batch' + ids).then(res => {
        if (res) {
          this.$message.success('批量删除成功');
          this.load();
        } else {
          this.$message.error('删除失败');
        }
      });
    },
    shutDown () {
      this.dialogFormVisible = false;
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize;
      this.load();
    },
    handleCurrentChange (pageNum) {
      this.pageNum = pageNum;
      this.load();
    }
  },
  watch: {
    comid (comid) {
      this.getPonds(comid);
    },
    pondid (/*pondid*/) {
      this.load();
    }
  }
}
</script>

<style scoped>
.upload-demo {
    margin: 15px 0;
}
.el-upload__tip {
    color: #666;
    font-size: 12px;
    margin-top: 5px;
}
</style>